module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2a7c73c010bf5fb6c7cd1021dfb8f39a.gif";